import script from "./rBarEcosystem.vue?vue&type=script&setup=true&lang=ts"
export * from "./rBarEcosystem.vue?vue&type=script&setup=true&lang=ts"

import "./rBarEcosystem.vue?vue&type=style&index=0&id=593b91da&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-593b91da"]])

export default __exports__